<div class="layout-column full-height">
  <app-bringoz-timeline-logs-table class="flex" [timeline]="timeline() ?? []"></app-bringoz-timeline-logs-table>
</div>
